module.exports = __webpack_public_path__ + "static/media/risk3.7c135d23.jpg";